import "./global.js";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./root.css";

import GlobalStyles from "./GlobalStyles";
import { BrowserRouter } from "react-router-dom";

import Modal, { ModalProvider } from "context/Modal";
import Notifications, { NotificationsProvider } from "./context/Notifications";

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyles />
    <NotificationsProvider>
      <ModalProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <Modal />
        <Notifications />
      </ModalProvider>
    </NotificationsProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
